export function getInitials(label: string): string {
    const cleaned = label.trim();
    if (!cleaned) return "?";
    if (cleaned.length <= 3) return cleaned.toUpperCase();
  
    const parts = cleaned.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 3).toUpperCase();
  
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }